export enum CampaignItemType {
    STILL = 'still',
    VIDEO = 'video',
    BANNER = 'banner',
}
